import React from "react";

type PropsType = {
  className?: string;
  size?: number;
};

const Questionaire: React.FC<PropsType> = ({ size = 60, className = "" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={size}
      height={size}
      viewBox="0 0 60 60"
      fill="none"
    >
      <circle
        cx="15.138"
        cy="29.9998"
        r="4.38894"
        fill="#FF878F"
        stroke="#003125"
        stroke-width="3"
      />
      <circle
        cx="15.138"
        cy="44.9221"
        r="4.38894"
        fill="#FF878F"
        stroke="#003125"
        stroke-width="3"
      />
      <path d="M28.3037 15.0776H50.2484" stroke="#003125" stroke-width="3" stroke-linecap="round" />
      <path d="M28.3037 30H50.2484" stroke="#003125" stroke-width="3" stroke-linecap="round" />
      <path d="M28.3037 44.9224H50.2484" stroke="#003125" stroke-width="3" stroke-linecap="round" />
      <path
        d="M10.75 15.9552L13.3834 18.5886L20.4057 10.6885"
        stroke="#003125"
        stroke-width="3.51115"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default Questionaire;
